import YZSRecorder from './yzs-sdk'
import ALIRecorder from './ali-sdk'
let initTimer = null
const oral = {
  yzsRecord: null,
  aliRecord: null,
  isEvaluation: true,
  initEngine() {
    var ua = window.navigator.userAgent || ''
    var isAndroid = /android/i.test(ua)
    if (typeof zhlWebView != 'undefined' && isAndroid) {
      if (initTimer) {
        clearTimeout(initTimer)
        initTimer = null
      }
      initTimer = setTimeout(() => {
        console.log('安卓判断权限超时-直接调用startInitEngine')
        startInitEngine()
      }, 1000)
      console.log('安卓判断权限')
      zhlWebView.checkRecordAudioPermission()
    } else {
      startInitEngine()
    }
  },
  //开始测评(语音测评，带英文)
  startEvaluation(englishText) {
    oral.isEvaluation = true
    oral.yzsRecord.startRecord(englishText, 'E', 'en')
  },
  //开始录音（语音识别，不带英文）
  startRecord() {
    oral.isEvaluation = false
    oral.aliRecord.startRecord()
  },
  //结束录音
  stopRecord() {
    if (oral.isEvaluation) {
      oral.yzsRecord.stopRecord()
    } else {
      oral.aliRecord.stopRecord()
    }
  },
  //云知声-测评结果
  yzsRecorderOnResult(params) {
    console.log('云知声-测评结果', params)
    window.oralRecAndEvaCallback(params)
  },
  //阿里云-语音识别结果
  aliRecorderOnResult(params) {
    console.log('阿里云-语音识别结果', params)
    window.oralRecAndEvaCallback(params)
  }
}

//安卓已授权
window.grantedRecordAudioPermission = function() {
  console.log('安卓判断权限-安卓已授权')
  if (initTimer) {
    clearTimeout(initTimer)
    initTimer = null
  }
  startInitEngine()
}

//安卓未授权
window.notGrantedRecordAudioPermission = function() {
  console.log('安卓判断权限-安卓未授权')
  if (initTimer) {
    clearTimeout(initTimer)
    initTimer = null
  }
  //去申请授权
  console.log('安卓-去申请授权')
  zhlWebView.toGrantedRecordAudioPermission()
}

// 初始化
function startInitEngine() {
  console.log('初始化语音测评')
  oral.yzsRecord = new YZSRecorder()
  oral.yzsRecord.recorderOnResult = oral.yzsRecorderOnResult
  oral.aliRecord = new ALIRecorder()
  oral.aliRecord.recorderOnResult = oral.aliRecorderOnResult
}

export default oral
